import { HeroUIProvider } from "@heroui/system";
import { WidgetConfigProvider } from "./widget-config-provider";
import { Suspense } from "react";
import { SWRConfig } from "swr";
import { swrFetcher } from "../lib/api";
import { Toaster } from "react-hot-toast";
import { WidgetThemeProvider } from "./widget-theme-provider";
import { useEffect } from "react";
import i18n from "../../i18n";

// SWR configuration for better performance
const swrConfig = {
  fetcher: swrFetcher,
  revalidateOnFocus: false, // Disable revalidation on window focus
  revalidateIfStale: true, // Only revalidate if data is stale
  dedupingInterval: 5000, // Dedupe similar requests within 5 seconds
  errorRetryCount: 3, // Limit error retries
};

export function Providers({
  children,
  locale,
}: {
  children: React.ReactNode;
  locale: string;
}) {
  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale]);

  return (
    <SWRConfig value={swrConfig}>
      <WidgetConfigProvider studioId={""}>
        <HeroUIProvider>
          <WidgetThemeProvider>{children}</WidgetThemeProvider>

          {/* Toast notifications are not critical for first render */}
          <Suspense fallback={null}>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: "#fff",
                  color: "#363636",
                },
              }}
            />
          </Suspense>
        </HeroUIProvider>
      </WidgetConfigProvider>
    </SWRConfig>
  );
}
